import React from 'react'
import TranslateText from '../../TranslateText'
import EntryTime from '../../PositionColumns/EntryTime'
import { Text, View } from '../../../../styles/reactnative'
import AdminCheckbox from '../../Admin/AdminCheckbox'
import Checkbox from 'rc-checkbox'
import TimeSave from '../../TimeSave'

export const column_group = mutate => {
	return [
		{
			title: '시장번호',
			dataIndex: 'id',
			key: 'id',
			align: 'center',
			width: 100,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '시장코드',
			dataIndex: 'code',
			key: 'code',
			align: 'center',
			width: 100,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '시장명',
			dataIndex: 'name',
			align: 'center',
			key: 'name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '시장명(한글)',
			dataIndex: 'name',
			align: 'center',
			key: 'name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '시작시간',
			dataIndex: 'starttime',
			align: 'center',
			key: 'name',
			render: (text, data) => {
				return (
					<TimeSave
						text={text}
						columnname={'starttime'}
						data={data}
						mutate={mutate}
					/>
				)
			},
		},
		{
			title: '종료시간',
			dataIndex: 'endtime',
			align: 'center',
			key: 'name',
			render: (text, data) => {
				return (
					<TimeSave
						text={text}
						columnname={'endtime'}
						data={data}
						mutate={mutate}
					/>
				)
			},
		},
		{
			title: '시작시간',
			dataIndex: 'starttime_break',
			align: 'center',
			key: 'name',
			render: (text, data) => {
				return (
					<TimeSave
						text={text}
						columnname={'starttime_break'}
						data={data}
						mutate={mutate}
					/>
				)
			},
		},
		{
			title: '종료시간',
			dataIndex: 'endtime_break',
			align: 'center',
			key: 'name',
			render: (text, data) => {
				return (
					<TimeSave text={text} columnname={'endtime_break'} data={data}
					mutate={mutate} />
				)
			},
		},
		{
			title: '시작시간',
			dataIndex: 'starttime2',
			align: 'center',
			key: 'name',
			render: (text, data) => {
				return (
					<TimeSave
						text={text}
						columnname={'starttime2'}
						data={data}
						mutate={mutate}
					/>
				)
			},
		},
		{
			title: '종료시간',
			dataIndex: 'endtime2',
			align: 'center',
			key: 'name',
			render: (text, data) => {
				return (
					<TimeSave text={text} columnname={'endtime2'} data={data}
					mutate={mutate} />
				)
			},
		},
	]
}
